import React from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// core components
import styles from 'assets/jss/material-dashboard-pro-react/components/cardStyle.js';

// @ts-ignore
const useStyles = makeStyles(styles);

type ICardColor =
	| 'primary'
	| 'secondary'
	| 'support1'
	| 'support2'
	| 'support3'
	| 'info'
	| 'success'
	| 'warning'
	| 'danger'
	| 'rose';

interface ICardProps {
	className?: string;
	plain?: boolean;
	profile?: boolean;
	blog?: boolean;
	raised?: boolean;
	background?: boolean;
	pricing?: boolean;
	testimonial?: boolean;
	color?: ICardColor;
	product?: boolean;
	chart?: boolean;
	login?: boolean;
	children?: string | React.ReactElement | React.ReactElement[];
	onClick?: () => void;
	'data-test-id'?: string;
}
const Card = ({
	className,
	children,
	plain,
	profile,
	blog,
	raised,
	background,
	pricing,
	color,
	product,
	testimonial,
	chart,
	login,
	...rest
}: ICardProps) => {
	const classes = useStyles();
	const cardClasses = classNames({
		[classes.card]: true,
		[classes.cardPlain]: plain,
		[classes.cardProfile]: profile || testimonial,
		[classes.cardBlog]: blog,
		[classes.cardRaised]: raised,
		[classes.cardBackground]: background,
		[classes.cardPricingColor]: (pricing && color !== undefined) || (pricing && background !== undefined),
		[classes[color]]: color,
		[classes.cardPricing]: pricing,
		[classes.cardProduct]: product,
		[classes.cardChart]: chart,
		[classes.cardLogin]: login,
		[className ? className : '']: className !== undefined,
	});
	return (
		<div className={cardClasses} {...rest}>
			{children}
		</div>
	);
};
export default Card;
